<template>
  <v-container fluid>
    <h2 class="text-md-center text-lg-center text-sm-center earth-color">Support Payment</h2>
      <div v-if="getDonation.payment_method !== 'MPESA'" class="col-md-10 card" style="margin-left: 15%; width: 70%">
        <v-tabs ripple>
          <v-tab ripple key="equity"><h5 class="earth-color" v-if="$paymentOptions[2].active === true && getDonation.currency === 'KES'">EQUITY</h5></v-tab>
          <v-tab ripple key="iveri"><h5 class="earth-color" v-if="$paymentOptions[0].active === true">IVERI</h5></v-tab>
          <v-tab-item key="equity" v-if="getDonation.currency === 'KES' && $paymentOptions[2].active === true">
            <v-container>
              <br>
              <h2 class="text-lg-center text-md-center text-sm-center earth-color">Support Payment</h2>
              <h4 class="text-lg-center text-md-center text-sm-center earth"> {{supportAmount / 100}}</h4>
              <div class="col-md-12 text-center">
                <form id="eazzycheckout-payment-form" action=" https://api-test.equitybankgroup.com/v2/checkout/launch" method="POST">
                  <input type="hidden" id="token" name="token" :value="$JengaAuth['payment_token']">
                  <input type="hidden" id="amount" name="amount" :value="supportAmount">
                  <input type="hidden" id="orderReference" name="orderReference" :value="getDonation.public_id">
                  <input type="hidden" id="merchantCode" name="merchantCode" value="8546918347">
                  <input type="hidden" id="merchant" name="merchant" value="Ol Pejeta Ranching Ltd" >
                  <input type="hidden" id="custName" name="custName" :value="getDonation.full_name">
                  <input type="hidden" id="outletCode" name="outletCode" value="0000000000">
                  <input type="hidden" id="popupLogo" name="popupLogo">
                  <input type="hidden" id="ez1_callbackurl" name="ez1_callbackurl">
                  <input type="hidden" id="ez2_callbackurl" name="ez2_callbackurl">
                  <input type="hidden" id="expiry" name="expiry" value="2025-02-17T19:00:00">
                  <v-btn type="submit" id="submit-cg" role="button" class="btn btn-primary col-md-4 text-center" value="Checkout" color="primary" target="_blank">Checkout</v-btn>
                </form>
                <p>* This is a KES based checkout</p>
              </div>
              <div class="row col-md-12 text-lg-center text-md-center text-sm-center">
                <img src="https://pbs.twimg.com/media/Dumm6dNW4AA7oDR.jpg" width="100%" height="100%" class="text-lg-center text-md-center text-sm-center center-block"/>
              </div>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="$paymentOptions[0].active === true">
             <div class="row col-md-12 text-lg-center text-md-center text-sm-center">
                    <img  src="https://www.freeiconspng.com/uploads/credit-cards-icon-25.png" width="25%" height="25%" />
                  </div>
            <v-container>
              <form id="myform" name="myform" METHOD="POST" ACTION="https://portal.host.iveri.com/Lite/Authorise.aspx">
                <!-- Mandatory form variables  -->
                <input v-if="getDonation.currency ==='USD'" id="Lite_Merchant_Applicationid" name="Lite_Merchant_Applicationid" type="hidden" :value="live_id" readonly="true">
                <input v-if="getDonation.currency ==='KES'" id="Lite_Merchant_Applicationid" name="Lite_Merchant_Applicationid" type="hidden" :value="kes_live_id" readonly="true">
                <input v-if="getDonation.currency ==='USD'" id="Lite_Order_Amount" name="Lite_Order_Amount" type="hidden" :value="supportAmount" readonly="true">
                <input v-if="getDonation.currency ==='KES'" id="Lite_Order_Amount" name="Lite_Order_Amount" type="hidden" :value="supportAmount" readonly="true">
                <input type="hidden" name="Lite_Website_Successful_url" :value="iveri_catcher_url + 'donation-payment'" /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_Fail_url" :value="iveri_url + 'support-us-payment/'+donationId" /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_TryLater_url" :value="iveri_url + 'support-us-payment/'+donationId" /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_Error_url" :value="iveri_url + 'support-us-payment/'+donationId" /> <!-- NEED TO BE CHANGED -->
                <input id="Lite_Currency_AlphaCode" name="Lite_Currency_AlphaCode" type="hidden" :value="currency" readonly="true">
                <input id="Lite_Order_LineItems_Product_1" name="Lite_Order_LineItems_Product_1" type="hidden" value="Donation Total" readonly="true">
                <input id="Lite_Order_LineItems_Quantity_1" name="Lite_Order_LineItems_Quantity_1" type="hidden" value="1" readonly="true">
                <input id="Lite_Order_LineItems_Amount_1" name="Lite_Order_LineItems_Amount_1" type="hidden" :value="supportAmount" readonly="true">
                <input id="Lite_ConsumerOrderID_PreFix" name="Lite_ConsumerOrderID_PreFix" type="hidden" value="DML" readonly="true">
                <input id="Ecom_BillTo_Online_Email" name="Ecom_BillTo_Online_Email" type="hidden" :value="getDonation.email">
                <input id="Ecom_Payment_Card_Protocols" name="Ecom_Payment_Card_Protocols" type="hidden" value="iVeri" readonly="true">
                <input id="DONATIONID" name="DONATIONID" type="hidden" :value="donationId">
                <input id="Ecom_TransactionComplete" name="Ecom_TransactionComplete" type="hidden" value="" readonly="true">
                <!-- End-->
                <font color="red"><p class="warningtext" id="warning" name="warning" >&nbsp;</p></font>
                <li>
                  <v-text-field
                    id="txtEmail"
                    name="txtEmail"
                    v-model="getDonation.email"
                    label="Email"
                    required
                  ></v-text-field>
                  <!--<input type="text" autocomplete="off" id="txtEmail" name="txtEmail" class="form-control" :value="singleBooking.booking_details.email_address" placeholder="Email"><a href="#" class=" icon user" tabindex="-1" ></a>-->
                </li>
                <li>
                  <input type="text" id="Amount" hidden="hidden" name="Amount" class="text" :value="supportAmount"><a href="#" class=" icon user" tabindex="-1"></a>
                </li>

                <br>
                <div class="submit">
                  <div class="row">
                      <v-btn :depressed="true" type="submit" id="btnsubmit" class="btn primary btn-block text-center" name="btnsubmit" large color="primary">Proceed to Card Payment</v-btn>
                  </div>
                  <br>
                  <br>
                  <h3 class="text-lg-center text-md-center text-sm-center center-block earth">PLEASE RE-CONFIRM YOUR EMAIL ADDRESS TO PROCEED WITH THE PAYMENT</h3>
                  <div class="clear">  </div>
                </div>
              </form>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </div>
      <v-layout v-if="getDonation.payment_method === 'MPESA'">
        <v-container>
          <v-card>
            <v-container>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12 offset-lg3 offset-md3>
                  <v-text-field
                    label="Safaricom Phone Number"
                    minlength="12"
                    maxlength="12"
                    v-model="phone_number"
                    required
                  ></v-text-field>
                 <v-layout row wrap>
                   <v-flex lg6 md6 sm12 xs12>
                     <v-btn :depressed="true" color="primary" block @click="requestMpesa()">Request Payment</v-btn>
                   </v-flex>
                   <v-flex lg6 md6 sm12 xs12 v-if="payment_requested === true">
                     <v-btn :depressed="true" color="warning" block @click="checkPayment()">Confirm Payment</v-btn>
                   </v-flex>
                 </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-container>
      </v-layout>
    <p v-if="getDonation.paid === 1">
      {{redirection}}
    </p>
  </v-container>
</template>

<script>
  export default {
    name: 'support-payment',
    data () {
      return {
        payment_requested: false,
        donationId: this.$route.params.donation_id,
        phone_number: '2547',
        currency: ''
      }
    },
    beforeCreate () {
      this.$store.dispatch('get_payment_platforms')
      this.$store.dispatch('get_jenga_auth')
    },
    created () {
      this.$store.dispatch('get_donation', this.$route.params.donation_id)
    },
    computed: {
      redirection () {
        this.redirect()
        return null
      },
      supportAmount: function () {
        if (this.allCurrencies.length > 0) {
          if (this.getDonation.payment_method_public_id === 'enjkr4k4') {
            if (this.getDonation.currency === 'KES') {
              this.changeCurrency('KES')
              return this.getDonation.amount * 100
            } else {
              this.changeCurrency('USD')
              var cardAmount = this.convert2(this.getDonation.currency, 'usd', this.getDonation.amount).amount
              return cardAmount * 100
            }
          } else if (this.getDonation.payment_method_public_id === 'emkrer') {
            var kes = {
              'created_at': null,
              'currency_description': 'The Kenyan Shilling.',
              'currency_name': 'KES',
              'currency_public_id': '162fface-f5f1-41de-913b-d2bb784dda3a',
              'currency_sign': 'KES',
              'session_id': 'Admin',
              'updated_at': null
            }
            this.currencyChange(kes)
            var mpesaAmount = this.convert2(this.getDonation.currency, 'usd', this.getDonation.amount).amount
            return mpesaAmount
          }
        }
        return null
      }
    },
    methods: {
      redirect () {
        this.$router.push({
          name: 'SuccessDonation'
        })
      },
      changeCurrency (currency) {
        this.currency = currency
      },
      checkPayment () {
        this.$store.dispatch('get_donation', this.$route.params.donation_id)
      },
      requestMpesa: function () {
        this.payment_requested = true
        var data = {
          donation_ref_code: this.$route.params.donation_id,
          phone_number: this.phone_number
        }
        this.$store.dispatch('donation_request_payment', data)
      }
    }
  }
</script>

<style scoped>
  li {
    text-decoration: none;
    list-style: none;
  }
</style>
